<template>
  <v-stepper-items>
    <v-stepper-content class="pa-0" step="4">
      <v-row justify="center">
        <v-col cols="12" sm="10" md="8" lg="6" xl="6">
          <v-container class="py-0">
            <v-card class="card py-5 my-3">
              <h3 class="text-center mb-3">{{ $t(["Waiver_Title"]) }}</h3>

              <v-divider class="mx-3"></v-divider>

              <div class="px-5 py-3">
                <span v-html="$t(['Waiver_Text_1'])" />

                <ul>
                  <li v-html="$t(['Waiver_Item_1'])" />
                  <li v-html="$t(['Waiver_Item_2'])" />
                  <li v-html="$t(['Waiver_Item_3'])" />
                  <li v-html="$t(['Waiver_Item_4'])" />
                </ul>

                <br />

                <span v-html="$t(['Waiver_Text_2_Bold'])" />
                <span v-html="$t(['Waiver_Text_2'])" />

                <br /><br />

                <span v-html="$t(['Waiver_Text_3_Bold'])" />
                <span v-html="$t(['Waiver_Text_3'])" />

                <br /><br />

                <span v-html="$t(['Waiver_Text_4_Bold'])" />
                <span v-html="$t(['Waiver_Text_4'])" />
              </div>

              <v-divider class="mx-3"></v-divider>

              <v-form ref="waiverForm">
                <v-row justify="center">
                  <v-checkbox
                    class="mb-3"
                    v-model="acceptWaiverCheckbox"
                    :rules="rules.waiver"
                  >
                    <template v-slot:label>
                      <div
                        :class="
                          acceptWaiverCheckbox == true
                            ? 'error--text'
                            : 'black--text'
                        "
                        translate
                      >
                        {{
                          $t([
                            "I accept the terms and conditions of this waiver",
                          ])
                        }}
                      </div>
                    </template>
                  </v-checkbox>
                </v-row>
              </v-form>

              <v-row>
                <v-col cols="6" align="center">
                  <v-btn class="btn-text" large @click="previousStep()">
                    {{ $t(["Back"]) }}
                  </v-btn>
                </v-col>

                <v-col cols="6" align="center">
                  <v-btn
                    class="btn-text"
                    color="primary"
                    large
                    @click="nextStep()"
                  >
                    {{ $t(["Next"]) }}
                  </v-btn>
                </v-col>
              </v-row>
            </v-card>
          </v-container>
        </v-col>
      </v-row>
    </v-stepper-content>
  </v-stepper-items>
</template>

<script>
export default {
  name: "S4_Waiver",
  data: () => {
    return {
      acceptWaiverCheckbox: [],
      rules: {
        waiver: [],
      },
    };
  },
  watch: {
    "$i18n.locale"() {
      this.$refs.waiverForm.resetValidation();
    },
    acceptWaiverCheckbox(state) {
      if (state.length == 1) {
        this.rules.waiver = [];
      }
    },
  },
  methods: {
    setFieldValidationRules() {
      this.rules.waiver = [
        this.acceptWaiverCheckbox.length > 0 || this.$t(["Required"]),
      ];
    },
    async nextStep() {
      await this.setFieldValidationRules();

      if (this.$refs.waiverForm.validate()) {
        this.$emit("nextStepFromFour");
      }
    },
    previousStep() {
      this.$emit("previousStepFromFour");
    },
  },
};
</script>

<style lang="scss" scoped></style>
